/**
 * MegaMenu Overflow Handler - More Dropdown
 * Converts overflow navigation items into a "More..." dropdown using existing template structure
 */

(function() {
    'use strict';

    // Configuration
    var HIDDEN_CLASS = 'overflow-hidden';
    var RESIZE_DEBOUNCE = 100;
    var MORE_TEXT = 'More';

    var navContainer = null;
    var originalItems = [];
    var moreDropdown = null;
    var resizeTimeout = null;
    var isChecking = false;

    /**
     * Initialize the overflow handler
     */
    function init() {
        navContainer = document.querySelector('.megaMenu__nav');
        if (!navContainer) return;

        // Store original navigation items (exclude any existing more dropdown)
        var items = navContainer.querySelectorAll('.megaMenu__nav--link:not(.more-dropdown-created)');
        originalItems = Array.prototype.slice.call(items);

        // Create more dropdown element
        createMoreDropdown();

        // Initial check and set up resize listener
        checkOverflow();
        window.addEventListener('resize', Core.Util.Debounce(checkOverflow, RESIZE_DEBOUNCE));
    }

    /**
     * Create the "More..." dropdown element using the template
     */
    function createMoreDropdown() {
        moreDropdown = document.createElement('li');
        moreDropdown.className = 'megaMenu__nav--link more-dropdown-created';
        moreDropdown.style.display = 'none';
        
        moreDropdown.innerHTML = 
            '<ul class="megaMenu__nav--more">' +
                '<li class="megaMenu__nav--more-item">' +
                    '<span class="megaMenu__nav--more-title">' + MORE_TEXT + '</span>' +
                    '<ul class="megaMenu__nav--more-children"></ul>' +
                '</li>' +
            '</ul>';

        navContainer.appendChild(moreDropdown);
        initializeKendoMenu();
    }

    /**
     * Initialize/refresh Kendo Menu for the More dropdown
     */
    function initializeKendoMenu() {
        setTimeout(function() {
            if (moreDropdown && window.$ && window.$.fn.kendoMenu) {
                var kendoMenu = moreDropdown.querySelector('.megaMenu__nav--more');
                if (kendoMenu) {
                    // Destroy existing widget if it exists
                    var kendoWidget = $(kendoMenu).data('kendoMenu');
                    if (kendoWidget) kendoWidget.destroy();
                    
                    // Initialize/re-initialize the menu
                    $(kendoMenu).kendoMenu({
                        animation: false,
                        hoverDelay: 0,
                        direction: "bottom right"
                    });
                }
            }
        }, 100);
    }

    /**
     * Check if navigation items overflow and manage dropdown
     */
    function checkOverflow() {        
        if (!navContainer || !moreDropdown || isChecking) return;
        
        isChecking = true;
        resetItems();
        
        var containerWidth = navContainer.offsetWidth;
        var moreWidth = getMeasuredMoreWidth();
        var totalWidth = 0;
        var visibleCount = 0;

        // Try to fit all items first
        for (var i = 0; i < originalItems.length; i++) {
            totalWidth += originalItems[i].offsetWidth;
            if (totalWidth <= containerWidth) {
                visibleCount = i + 1;
            } else {
                break;
            }
        }

        // If not all items fit, account for "More" button
        if (visibleCount < originalItems.length) {
            totalWidth = 0;
            visibleCount = 0;
            var availableWidth = containerWidth - moreWidth;
            
            for (var j = 0; j < originalItems.length; j++) {
                var itemWidth = originalItems[j].offsetWidth;
                if (totalWidth + itemWidth <= availableWidth) {
                    totalWidth += itemWidth;
                    visibleCount++;
                } else {
                    break;
                }
            }
        }

        // Apply visibility changes
        applyVisibility(visibleCount);
        isChecking = false;
        
        Core.Engine.initStickyHeader();
    }

    /**
     * Get measured width of "More" button
     */
    function getMeasuredMoreWidth() {
        moreDropdown.style.display = 'inline-block';
        moreDropdown.style.visibility = 'hidden';
        
        var moreTitleSpan = moreDropdown.querySelector('.megaMenu__nav--more-title');
        var width = (moreTitleSpan ? moreTitleSpan.offsetWidth : moreDropdown.offsetWidth) + 26;
        
        moreDropdown.style.display = 'none';
        moreDropdown.style.visibility = 'visible';
        
        return width;
    }

    /**
     * Apply visibility based on visible count
     */
    function applyVisibility(visibleCount) {
        var hasHiddenItems = visibleCount < originalItems.length;
        
        // Hide overflow items
        for (var i = visibleCount; i < originalItems.length; i++) {
            originalItems[i].classList.add(HIDDEN_CLASS);
        }

        // Show/hide more dropdown
        if (hasHiddenItems) {
            populateMoreDropdown(originalItems.slice(visibleCount));
            moreDropdown.style.display = 'inline-block';
            initializeKendoMenu();
        } else {
            moreDropdown.style.display = 'none';
        }
    }

    /**
     * Populate the more dropdown with hidden items
     */
    function populateMoreDropdown(hiddenItems) {
        var dropdownContent = moreDropdown.querySelector('.megaMenu__nav--more-children');
        if (!dropdownContent) return;

        dropdownContent.innerHTML = '';

        for (var i = 0; i < hiddenItems.length; i++) {
            var item = hiddenItems[i];
            var link = item.querySelector('a');
            if (!link) continue;

            var listItem = document.createElement('li');
            listItem.className = 'megaMenu__nav--more-child';
            
            var dropdownLink = document.createElement('a');
            dropdownLink.className = 'megaMenu__nav--more-link';
            dropdownLink.href = link.href;
            dropdownLink.textContent = link.textContent.replace(/\s+/g, ' ').trim();
            dropdownLink.title = link.title || dropdownLink.textContent;
            
            // Copy special attributes
            if (link.target) dropdownLink.target = link.target;
            if (link.classList.contains('current')) dropdownLink.classList.add('current');

            listItem.appendChild(dropdownLink);
            dropdownContent.appendChild(listItem);
        }
    }

    /**
     * Reset all items to visible state
     */
    function resetItems() {
        for (var i = 0; i < originalItems.length; i++) {
            originalItems[i].classList.remove(HIDDEN_CLASS);
            originalItems[i].style.display = '';
        }
    }

    /**
     * Cleanup function
     */
    function destroy() {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
            resizeTimeout = null;
        }
        window.removeEventListener('resize', checkOverflow);
        resetItems();
        if (moreDropdown && moreDropdown.parentNode) {
            moreDropdown.parentNode.removeChild(moreDropdown);
        }
    }

    // Auto-initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose global interface
    window.MegaMenuOverflow = {
        init: init,
        check: checkOverflow,
        destroy: destroy
    };

})();